/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Guest_LabelInputs */

const en_rental_guest_label = /** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

const es_rental_guest_label = /** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huésped`)
};

const fr_rental_guest_label = /** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invité`)
};

const de_rental_guest_label = /** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gast`)
};

const id_rental_guest_label = /** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu`)
};

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const ja_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const zh_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const ar_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const it_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const ru_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const pt_rental_guest_label = en_rental_guest_label;

/** @type {(inputs: Rental_Guest_LabelInputs) => LocalizedString} */
const ko_rental_guest_label = en_rental_guest_label;

/**
* | output |
* | --- |
* | "Guest" |
*
* @param {Rental_Guest_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_guest_label = /** @type {((inputs?: Rental_Guest_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Guest_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_guest_label(inputs)
	if (locale === "es") return es_rental_guest_label(inputs)
	if (locale === "fr") return fr_rental_guest_label(inputs)
	if (locale === "de") return de_rental_guest_label(inputs)
	if (locale === "ja") return ja_rental_guest_label(inputs)
	if (locale === "zh") return zh_rental_guest_label(inputs)
	if (locale === "ar") return ar_rental_guest_label(inputs)
	if (locale === "id") return id_rental_guest_label(inputs)
	if (locale === "it") return it_rental_guest_label(inputs)
	if (locale === "ru") return ru_rental_guest_label(inputs)
	if (locale === "pt") return pt_rental_guest_label(inputs)
	return ko_rental_guest_label(inputs)
});